import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import Header from "../components/Header";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { ShieldCheck, Loader2 } from "lucide-react";
import { formatApiError } from "../lib/api";

export default function AdminLoginPage() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="border border-slate-200 bg-white rounded-lg p-8">
          <div className="h-10 w-10 rounded-md bg-slate-900 text-white grid place-items-center mb-4">
            <ShieldCheck size={18} />
          </div>
          <h1 className="font-display text-2xl font-semibold tracking-tight">
            Acceso administrador
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Ingresa tus credenciales para gestionar lotes y reservas.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
              />
            </div>
            <div>
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" data-testid="admin-login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              className="w-full bg-slate-900 hover:bg-slate-800"
              disabled={submitting}
              data-testid="admin-login-submit"
            >
              {submitting ? (
                <span className="inline-flex items-center gap-2">
                  <Loader2 size={14} className="animate-spin" /> Ingresando…
                </span>
              ) : (
                "Ingresar"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
